import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import type { GPDataProvider } from '../index';
import type {
  ReportClickMerchantCreate,
  ReportClickMerchantCreateParams,
} from '../CustomMethods/Report';
import { type ActionHook, type ActionOptions, stableSerialize } from './types';

export function useReportClickMerchantCreate(
  initialArgs?: ReportClickMerchantCreateParams,
  options?: ActionOptions<
    ReportClickMerchantCreateParams,
    Awaited<ReturnType<ReportClickMerchantCreate>>
  >,
): ActionHook<ReportClickMerchantCreateParams, Awaited<ReturnType<ReportClickMerchantCreate>>> {
  const dataProvider = useDataProvider<GPDataProvider>();
  const queryClient = useQueryClient();
  const mutation = useMutation<
    Awaited<ReturnType<ReportClickMerchantCreate>>,
    Error,
    ReportClickMerchantCreateParams
  >({
    ...options,
    mutationFn: (args) =>
      queryClient.fetchQuery({
        queryKey: [
          'custom-action',
          'reportClickMerchantCreate',
          stableSerialize(args ?? initialArgs),
        ],
        queryFn: () =>
          dataProvider.reportClickMerchantCreate(
            args ?? initialArgs ?? ({} as ReportClickMerchantCreateParams),
          ),
        staleTime: 5 * 60 * 1000,
      }),
  });
  return [
    (args, callOptions) =>
      mutation.mutateAsync(
        args ?? initialArgs ?? ({} as ReportClickMerchantCreateParams),
        callOptions,
      ),
    mutation,
  ];
}
